var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C12.2246 0 12.4492 0.0488281 12.6543 0.141602L21.8487 4.04297C22.9229 4.49707 23.7237 5.55664 23.7188 6.83594C23.6944 11.6797 21.7022 20.542 13.2891 24.5703C12.4737 24.9609 11.5264 24.9609 10.711 24.5703C2.29787 20.542 0.305686 11.6797 0.281272 6.83594C0.276389 5.55664 1.07717 4.49707 2.15139 4.04297L11.3506 0.141602C11.5508 0.0488281 11.7754 0 12 0ZM12 3.26172V21.7236C18.7383 18.457 20.5498 11.2354 20.5938 6.9043L12 3.26172Z",
    fill: "#077D65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.2e842f0c94714a39f742a0876f552b31.svg";
export { ForwardRef as ReactComponent };